export default "__VITE_ASSET__BTAxGFLL__"